import React from "react";
import { Select } from "antd";
import useMyEmployees from "../../hooks/useMyEmployees";
import MultiSelectNoContent from "../MultiSelectNoContent/MultiSelectNoContent";

const { Option } = Select;

const EmployeesSelect = (props) => {
  const myEmployees = useMyEmployees();
  return (
    <Select
      {...props}
      mode="multiple"
      placeholder="Select team members"
      showArrow
      style={{ width: "72vw", maxWidth: "450px" }}
      defaultValue={props.defaultValue}
      notFoundContent={<MultiSelectNoContent message="No employees found" />}
      getPopupContainer={(triggerNode) => triggerNode}
    >
      {myEmployees &&
        myEmployees.map((employee) => (
          <Option
            key={employee.fullName}
            value={employee.email}
            style={{ color: "#37519d", border: "0.25px solid #727272" }}
          >
            {employee.fullName}
          </Option>
        ))}
    </Select>
  );
};

export default EmployeesSelect;
